import { Component, OnInit, Input } from '@angular/core';

import { MetaFileLink, MediaType } from 'src/app/models/metaFileLink.model';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'terra-document-thumbnail',
  templateUrl: './document-thumbnail.component.html',
  styleUrls: ['./document-thumbnail.component.scss']
})
export class DocumentThumbnailComponent implements OnInit {

  @Input() metaFileLink: MetaFileLink;
  @Input() isClickable: boolean;
  @Input() truncateSize = 45;

  mediaType: MediaType = MediaType.Unknown;
  iconName = 'file_general';

  get downloadUrl() {
    return this.metaFileLink.url;
  }

  constructor(private utilsService: UtilsService) { }

  ngOnInit() {
    this.mediaType = MetaFileLink.GetMediaType(this.metaFileLink);
    switch (this.mediaType) {
      case MediaType.Unknown:
        this.iconName = 'file_general';
        break;
      case MediaType.TextDocument:
        this.iconName = 'file_doc';
        break;
      case MediaType.Spreadsheet:
        this.iconName = 'file_excel';
        break;
      case MediaType.Pdf:
        this.iconName = 'file_pdf';
        break;
      case MediaType.Presentation:
        this.iconName = 'file_ppt';
        break;
    }
  }
}
